
/**
 * @author lifei
 * 模块说明：接口模块出口
 */
        
// 渠道店铺管理
import { StoreService } from './store'
export const store = new StoreService('/api/channel/store')
        
// 渠道管理
import { ChannelService } from './channel'
export const channel = new ChannelService('/api/channel/channel')
        